import React, { useEffect, useState, useRef } from 'react';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'none';
}
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: FadeInProps) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, []);
  const baseClasses = 'transition-all duration-1000 ease-out';
  const stateClasses = isVisible ? 'opacity-100 translate-y-0' : `opacity-0 ${direction === 'up' ? 'translate-y-5' : ''}`;
  return <div ref={ref} className={`${baseClasses} ${stateClasses} ${className}`} style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-27">
      {children}
    </div>;
}